<template>
    <Modal
        :value="visible"
        :title="modalTitle"
        :mask-closable="false"
        footer-hide
        :width="modalWidth"
        class-name="version-intro-modal"
        @on-visible-change="onVisibleChange"
    >
        <version-package-plans
            ref="plans"
            :collapsible-compare="true"
            :active="visible"
            :version-user-info="versionUserInfo"
            @compare-change="compareExpanded = $event"
            @paid="$emit('paid')"
        />
    </Modal>
</template>

<script>
import VersionPackagePlans from './Plans'
import { getCompareTitle } from '../config'

export default {
    name: 'VersionPackageIntroModal',
    components: { VersionPackagePlans },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        versionUserInfo: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            compareExpanded: false
        }
    },
    computed: {
        isCA() {
            return Number(this.$store.state.is_mainland) === 1
        },
        modalTitle() {
            return getCompareTitle(this.isCA)
        },
        modalWidth() {
            return this.compareExpanded ? 1180 : 1000
        }
    },
    methods: {
        onVisibleChange(val) {
            if (!val) {
                this.$emit('update:visible', false)
                this.compareExpanded = false
                if (this.$refs.plans) {
                    this.$refs.plans.resetCompare()
                }
                return
            }
            this.$emit('update:visible', true)
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep .version-intro-modal {
    .ivu-modal-body {
        padding: 20px 32px 32px;
        max-height: 85vh;
        overflow-y: auto;
    }
}
</style>
